import React, { useState } from "react";
import FontIcon from "react-md/lib/FontIcons";
import NavigoAPIServices from "../services/navigoAPIServices";
import EventService from "../../../../../service/event/EventService";
import AuthenticationService from "../../../../../service/auth/AuthenticationService";
import "react-quill/dist/quill.snow.css";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
function DisqualificationUser(props) {
  const [disqualifyInputs, setDisqualifyInputs] = useState([
    { patientId: "", reason: EditorState.createEmpty() },
  ]);

  const [isChallengeIdDisabled, setIsChallengeIdDisabled] = useState(false);

  const [disqualifyType, setDisqualifyType] = useState();
  const [layout, setLayout] = useState(1);

  const [challengeName, setChallengeName] = useState("");
  const [accountCode, setAccountCode] = useState("");

  const [showDisqualifyBox, setShowDisqualifyBox] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [errorResponse, setErrorResponse] = useState({});
  const [totalReq, setTotalReq] = useState(0);
  const [totalSuccess, setTotalSuccess] = useState(0);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleDisqualifyInputChange = (index, field, value) => {
    const updatedInputs = [...disqualifyInputs];
    updatedInputs[index][field] = value;
    setDisqualifyInputs(updatedInputs);
  };

  const addNewDisqualifyField = () => {
    setDisqualifyInputs([...disqualifyInputs, { patientId: "", reason: "" }]);
  };

  const handleSaveDisqualifiedUsers = () => {
    const body = {
      challengeId: Number(disqualifyType),
      input: disqualifyInputs.map((item) => ({
        patientId: Number(item.patientId),
        reason: draftToHtml(convertToRaw(item.reason.getCurrentContent())),
      })),
    };

    navigoAPIServices.disqualifyUser(
      body,
      (res) => {
        const errResp = res.errorResponse || {};
        setErrorResponse(errResp);
        setTotalReq(res.totalRequested || 0);
        setTotalSuccess(res.totalSuccess || 0);

        if (Object.keys(errResp).length === 0) {
          setShowConfirmModal(false);
          props.changeLayout();
          EventService.emit("showError", {
            message: "Users disqualified successfully.",
          });
        } else {
          setShowConfirmModal(false);
          setShowErrorModal(true);
        }
      },
      (err) => {
        console.error(err);
        EventService.emit("showError", { message: err.message });
      }
    );
  };
  const removeDisqualifyField = (indexToRemove) => {
    setDisqualifyInputs((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleContinue = () => {
    if (!disqualifyType) return;

    navigoAPIServices.getChallengeDetails(
      disqualifyType,
      (res) => {
        setChallengeName(res?.challengeDetails?.name || "");
        setAccountCode(res?.challengeDetails?.accountCode || "");
        setShowDisqualifyBox(true);
        setIsChallengeIdDisabled(true);
      },
      (err) => {
        console.log("Failed to fetch", err);
        EventService.emit("showError", { message: err.message });
      }
    );
  };
  const navigoAPIServices = new NavigoAPIServices();
  const authenticationService = new AuthenticationService();

  return (
    <>
      {" "}
      {showErrorModal && (
        <div className="modal-overlay">
          <div className="modal error-modal">
            <h3>Error disqualifying PID’s</h3>
            <div className="error-modal-content" style={{ textAlign: "left" }}>
              <p>
                {totalSuccess} out of {totalReq} PID’s have been disqualified
                successfully but there are some errors in{" "}
                {totalReq - totalSuccess} PID’s, please rectify and try again
              </p>

              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  textAlign: "left",
                  paddingRight: "10px",
                }}
              >
                {Object.entries(errorResponse).map(([pid, errMsg], index) => (
                  <div key={index} style={{ marginBottom: "10px" }}>
                    <strong>PID:</strong> {pid} <br />
                    <strong>Error:</strong> {errMsg}
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-actions-error">
              <button
                className="confirm-btn"
                onClick={() => {
                  setShowErrorModal(false);
                }}
              >
                Retry
              </button>
              <button
                className="cancel-btn"
                onClick={() => setShowErrorModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal confirm-modal">
            <p>
              Are you sure you want to disqualify all the PID’s you have
              provided, once confirmed these users will be disqualified from the
              challenge
            </p>
            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={() => {
                  handleSaveDisqualifiedUsers();
                }}
              >
                Confirm
              </button>
              <button
                className="cancel-btn"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="navigo-appoint-container-dis">
        <div className="top-bar">
          <div className="header-row">
            <div className="back-icon" onClick={props.changeLayout}>
              <FontIcon style={{ color: "orange" }}>arrow_back</FontIcon>
            </div>
            <h1 className="title">Disqualify users from challenge</h1>
          </div>

          <div className="top-actions">
            <div className="top-actions">
              <button
                className="save-btn"
                onClick={() => setShowConfirmModal(true)}
                disabled={
                  disqualifyInputs.length === 0 ||
                  disqualifyInputs.some(
                    (input) =>
                      !input.patientId ||
                      !input.reason ||
                      input.reason.getCurrentContent().getPlainText().trim() ===
                        ""
                  )
                }
              >
                Save
              </button>
              <button className="cancel-btn" onClick={props.changeLayout}>
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="input-group" style={{ maxWidth: "250px" }}>
            <label>Challenge ID</label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="Type here"
              value={disqualifyType}
              disabled={isChallengeIdDisabled}
              onChange={(e) =>
                setDisqualifyType(e.target.value.replace(/\D/g, ""))
              }
            />
          </div>

          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={isChallengeIdDisabled}
          >
            Continue
          </button>

          {challengeName && (
            <>
              <div className="input-group">
                <label>Challenge name</label>
                <input type="text" value={challengeName} disabled />
              </div>
              <div className="input-group">
                <label>Account code</label>
                <input type="text" value={accountCode} disabled />
              </div>
            </>
          )}
        </div>

        {showDisqualifyBox && (
          <div className="disqualify-input-wrapper">
            {disqualifyInputs.map((input, index) => (
              <div className="disqualify-card" key={index}>
                <div className="disqualify-header">
                  <label className="field-label">
                    PID <span className="required">*</span>
                  </label>
                  <div className="pid-input-row">
                    <input
                      type="number"
                      value={input.patientId}
                      className="input-underline"
                      onChange={(e) =>
                        handleDisqualifyInputChange(
                          index,
                          "patientId",
                          e.target.value
                        )
                      }
                    />
                    <button
                      className="remove-btn"
                      onClick={() => removeDisqualifyField(index)}
                    >
                      &times;
                    </button>
                  </div>
                </div>

                <div className="disqualify-reason">
                  <label>
                    Reason <span className="required">*</span>
                  </label>
                  <Editor
                    editorState={input.reason}
                    onEditorStateChange={(editorState) =>
                      handleDisqualifyInputChange(index, "reason", editorState)
                    }
                    toolbar={{
                      options: ["inline", "list", "history", "remove"],
                      inline: {
                        options: [
                          "bold",
                          "italic",
                          "underline",
                          "strikethrough",
                          "monospace",
                        ],
                      },
                      list: {
                        options: ["unordered", "ordered"],
                      },
                    }}
                    toolbarClassName="navigo-toolbar-class"
                    wrapperClassName="navigo-service-sd-wrapper-editor-wrapper-class"
                    editorClassName="navigo-service-sd-editor-wrapper-editor-class"
                    placeholder="Type reason here..."
                  />
                </div>
              </div>
            ))}

            <div className="disqualify-actions">
              <button className="add-new-btn" onClick={addNewDisqualifyField}>
                + Add new
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DisqualificationUser;
